module.exports = __webpack_public_path__ + "img/19.184a1d1.jpg";